if (!customElements.get('pdp-subscribe')) {
  customElements.define(
    'pdp-subscribe',
    class PdpSubscribe extends HTMLElement {
      connectedCallback() {
        this.planInput = this.querySelector('[data-pdp-selling-plan]');
        this.refillPlanInput = this.querySelector('[data-pdp-refill-plan]');
        this.cards = this.querySelectorAll('[data-pdp-mode]');
        this.dropdown = this.querySelector('[data-pdp-dropdown]');
        this.trigger = this.querySelector('[data-pdp-dropdown-trigger]');
        this.list = this.querySelector('[data-pdp-dropdown-list]');
        this.label = this.querySelector('[data-pdp-dropdown-label]');
        this.options = this.querySelectorAll('[data-pdp-plan-id]');
        this.subPrice = this.querySelector('[data-pdp-sub-price]');
        this.subCompare = this.querySelector('[data-pdp-sub-compare]');
        this.oneTimePrice = this.querySelector('[data-pdp-onetime-price]');
        this.todayTotal = this.querySelector('[data-pdp-today-total]');
        this.recurring = this.querySelector('[data-pdp-recurring]');
        this.recurringPrice = this.querySelector('[data-pdp-recurring-price]');
        this.root = this.closest('product-info') || document;
        this.form = document.getElementById(this.dataset.formId);
        this.unitPrice = Number(this.dataset.unitPrice) || 0;
        this.brushPrice = Number(this.dataset.brushPrice) || 0;
        this.headPrice = Number(this.dataset.headPrice) || 0;
        this.isRefill = this.dataset.refill === 'true';
        this.atcPlanLabel = this.dataset.atcPlanLabel || 'Subscribe and Save';
        this.refillVariantMap = [];
        try {
          this.refillVariantMap = JSON.parse(this.dataset.pdpRefillVariants || '[]');
        } catch (error) {
          this.refillVariantMap = [];
        }
        this.mode = this.dataset.defaultMode || 'subscribe';
        this.selectedOption = this.querySelector('.pdp-sub__dropdown-option.is-active') || this.options[0];
        this.packPrice = this.isRefill ? this.brushPrice : this.unitPrice;
        this.packCompare = Number(this.selectedOption?.dataset.pdpPlanCompare) || this.unitPrice;
        if (this.isRefill) {
          const brushCompare = Number(this.dataset.brushCompare) || 0;
          this.packCompare = brushCompare > this.brushPrice ? brushCompare : this.brushPrice;
        }
        this.adding = false;
        this.formBound = false;
        const activePack = this.root.querySelector('[data-pdp-pack].is-active');
        if (activePack && !this.isRefill) {
          this.packPrice = Number(activePack.dataset.price) || this.packPrice;
          this.packCompare = Number(activePack.dataset.compare) || this.packCompare;
        }

        const atcLabel = this.root.querySelector('.pdp-atc__label');
        this.atcDefaultLabel = atcLabel ? atcLabel.textContent.trim() : 'Add to cart';

        this.onPackChange = this.onPackChange.bind(this);
        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.onVariantChange = this.onVariantChange.bind(this);
        this.onDocumentVariantChange = this.onDocumentVariantChange.bind(this);
        this.root.addEventListener('pdp:pack-change', this.onPackChange);
        document.addEventListener('variant:changed', this.onDocumentVariantChange);
        if (window.FoxTheme?.pubsub?.subscribe) {
          this.variantUnsub = FoxTheme.pubsub.subscribe(
            FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
            this.onVariantChange
          );
        }
        this.bindForm();

        this.bindEvents();
        this.applyMode(this.mode);
        this.syncPlanInput();
        this.syncPackDisplays();
      }

      bindForm() {
        this.form = document.getElementById(this.dataset.formId);
        if (this.isRefill && this.form && !this.formBound) {
          this.form.addEventListener('submit', this.onFormSubmit, true);
          this.formBound = true;
        }
      }

      disconnectedCallback() {
        this.root?.removeEventListener('pdp:pack-change', this.onPackChange);
        this.form?.removeEventListener('submit', this.onFormSubmit, true);
        document.removeEventListener('variant:changed', this.onDocumentVariantChange);
        this.variantUnsub?.();
      }

      onVariantChange(event) {
        const data = event?.data || {};
        const sectionId = this.root?.dataset?.section;
        const originalSection = this.root?.dataset?.originalSection;
        if (
          data.sectionId &&
          sectionId &&
          data.sectionId !== sectionId &&
          data.sectionId !== originalSection
        ) {
          return;
        }
        this.applyVariant(data.variant);
      }

      onDocumentVariantChange(event) {
        const variant = event.detail?.variant;
        if (!variant) return;
        const input = this.form?.querySelector('[name="id"]');
        if (input?.value && String(input.value) !== String(variant.id)) return;
        this.applyVariant(variant);
      }

      applyVariant(variant) {
        const row = this.root.querySelector('[data-pdp-price-row]');
        if (!variant) {
          row?.classList.add('hidden');
          return;
        }
        row?.classList.remove('hidden');

        const price = Number(variant.price) || 0;
        const compareAt = Number(variant.compare_at_price) || 0;
        if (price) {
          this.unitPrice = price;
          this.dataset.unitPrice = String(price);
        }

        const hasPacks = Boolean(this.root.querySelector('[data-pdp-pack]'));
        if (this.isRefill) {
          if (price) this.brushPrice = price;
          this.packCompare = compareAt > price ? compareAt : price;
          this.syncRefillVariant(variant);
        } else if (!hasPacks && price) {
          this.packPrice = price;
          this.packCompare = compareAt > price ? compareAt : price;
        }

        this.options = this.querySelectorAll('[data-pdp-plan-id]');
        const allocations = variant.selling_plan_allocations || [];
        this.options.forEach((option) => {
          const planId = Number(option.dataset.pdpPlanId);
          const allocation = allocations.find((item) => Number(item.selling_plan_id) === planId);
          if (!allocation) return;
          option.dataset.pdpPlanPrice = String(allocation.price);
          option.dataset.pdpPlanCompare = String(Number(allocation.compare_at_price) || price);
        });

        this.refreshPackPrices();
        this.syncPackDisplays();
        this.syncPlanInput();
        this.syncRefillSummary();
        this.syncAtcLabel();
      }

      onPackChange(event) {
        if (this.isRefill) return;
        const { price, compare } = event.detail || {};
        if (price) this.packPrice = Number(price);
        if (compare != null) this.packCompare = Number(compare);
        this.refreshPackPrices();
        this.syncAtcPrices();
        this.syncPackDisplays();
      }

      bindEvents() {
        this.modeInputs = this.querySelectorAll('[data-pdp-mode-input]');
        this.modeInputs.forEach((input) => {
          input.addEventListener('change', () => {
            if (input.checked) this.applyMode(input.value);
          });
        });

        this.cards.forEach((card) => {
          card.addEventListener('click', (event) => {
            if (event.target.closest('[data-pdp-dropdown]')) return;
            this.applyMode(card.dataset.pdpMode);
          });
        });

        if (this.trigger) {
          this.trigger.addEventListener('click', (event) => {
            event.stopPropagation();
            this.toggleDropdown();
          });
        }

        this.options.forEach((option) => {
          option.addEventListener('click', (event) => {
            event.stopPropagation();
            this.selectPlan(option);
            this.closeDropdown();
            this.applyMode('subscribe');
          });
        });

        document.addEventListener('click', (event) => {
          if (!this.contains(event.target)) this.closeDropdown();
        });

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') this.closeDropdown();
        });
      }

      applyMode(mode) {
        this.mode = mode;
        this.cards.forEach((card) => {
          const selected = card.dataset.pdpMode === mode;
          card.classList.toggle('is-selected', selected);
          const input = card.querySelector('[data-pdp-mode-input]');
          if (input) input.checked = selected;
        });
        this.syncPlanInput();
        this.syncRefillSummary();
        this.syncAtcLabel();
        this.syncPackDisplays();
      }

      selectPlan(option) {
        this.selectedOption = option;
        this.options.forEach((item) => {
          const active = item === option;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        if (this.label) this.label.textContent = option.dataset.pdpPlanName;
        this.refreshPackPrices();
        this.syncPlanInput();
        this.syncPackDisplays();
      }

      scaledPlanPrice() {
        if (!this.unitPrice || !this.selectedOption) return this.packPrice;
        const unitPlan = Number(this.selectedOption.dataset.pdpPlanPrice) || this.unitPrice;
        return this.packPrice * (unitPlan / this.unitPrice);
      }

      planRatio() {
        if (this.mode !== 'subscribe' || !this.unitPrice || !this.selectedOption) return 1;
        const unitPlan = Number(this.selectedOption.dataset.pdpPlanPrice) || this.unitPrice;
        return unitPlan / this.unitPrice;
      }

      syncPackDisplays() {
        if (this.isRefill) {
          if (this.dataset.pdpBrushHeadline === 'true') {
            const compare = this.packCompare > this.brushPrice ? this.packCompare : this.brushPrice;
            const off =
              compare > this.brushPrice ? Math.round(((compare - this.brushPrice) / compare) * 100) : 0;
            this.syncHeadlinePrice(this.brushPrice, compare, off);
          }
          return;
        }
        const ratio = this.planRatio();
        this.root.querySelectorAll('[data-pdp-pack]').forEach((card) => {
          const otp = Number(card.dataset.price) || 0;
          const otpCompare = Number(card.dataset.compare) || otp;
          const shown = Math.round(otp * ratio);
          const compare = otpCompare;
          const qty = Number(card.dataset.qty) || 1;
          const unit = card.dataset.unit || 'tube';
          const priceEl = card.querySelector('.pdp-packs__price');
          const compareEl = card.querySelector('.pdp-packs__compare');
          const eachEl = card.querySelector('.pdp-packs__each');
          const offEl = card.querySelector('.pdp-packs__off');
          const packOff = Number(card.dataset.off) || 0;
          const stackedOff = compare > shown ? Math.round(((compare - shown) / compare) * 100) : 0;
          const off = this.mode === 'subscribe' ? stackedOff : packOff;
          if (priceEl) priceEl.textContent = this.formatMoney(shown);
          if (compareEl) {
            if (compare > shown) {
              compareEl.textContent = this.formatMoney(compare);
              compareEl.hidden = false;
            } else {
              compareEl.hidden = true;
            }
          }
          if (offEl) {
            if (off > 0) {
              offEl.textContent = `${off}% OFF`;
              offEl.hidden = false;
            } else {
              offEl.hidden = true;
            }
          }
          if (eachEl) eachEl.textContent = `${this.formatMoney(Math.round(shown / qty))}/per ${unit}`;
        });

        const active = this.root.querySelector('[data-pdp-pack].is-active');
        const otp = active ? Number(active.dataset.price) || this.packPrice : this.packPrice;
        const otpCompare = active
          ? Number(active.dataset.compare) || otp
          : this.packCompare || this.packPrice;
        const shown = Math.round(otp * ratio);
        const compare = otpCompare;
        const packOff = active ? Number(active.dataset.off) || 0 : 0;
        const stackedOff = compare > shown ? Math.round(((compare - shown) / compare) * 100) : 0;
        const off = this.mode === 'subscribe' ? stackedOff : packOff;
        this.syncHeadlinePrice(shown, compare, off);
      }

      syncHeadlinePrice(price, compare, off) {
        const row = this.root.querySelector('[data-pdp-price-row]');
        if (!row) return;
        const compareEl = row.querySelector('[data-pdp-price-compare]');
        const saleEl = row.querySelector('[data-pdp-price-sale]');
        const saveEl = row.querySelector('[data-pdp-price-save]');
        if (saleEl) saleEl.textContent = this.formatMoney(price);
        if (compareEl) {
          if (compare > price) {
            compareEl.textContent = this.formatMoney(compare);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
        if (saveEl) {
          if (off > 0 && compare > price) {
            saveEl.textContent = `save ${this.formatMoney(compare - price)} (${off}% OFF)`;
            saveEl.hidden = false;
          } else {
            saveEl.hidden = true;
          }
        }
      }

      refreshPackPrices() {
        if (this.isRefill) return;
        if (this.oneTimePrice) this.oneTimePrice.textContent = this.formatMoney(this.packPrice);
        if (this.subPrice) this.subPrice.textContent = this.formatMoney(this.scaledPlanPrice());
        if (this.subCompare) {
          const compare = this.packCompare || this.packPrice;
          this.subCompare.textContent = this.formatMoney(compare);
          this.subCompare.hidden = compare <= this.scaledPlanPrice();
        }
      }

      syncPlanInput() {
        if (!this.planInput) return;
        if (this.isRefill) {
          this.planInput.value = '';
          this.planInput.setAttribute('disabled', 'disabled');
        } else if (this.mode === 'subscribe' && this.selectedOption) {
          this.planInput.value = this.selectedOption.dataset.pdpPlanId;
          this.planInput.removeAttribute('disabled');
        } else {
          this.planInput.value = '';
          this.planInput.setAttribute('disabled', 'disabled');
        }
        this.syncAtcPrices();
      }

      syncRefillSummary() {
        if (!this.isRefill) return;
        const withPlan = this.mode === 'subscribe';
        const today = withPlan ? this.brushPrice + this.headPrice : this.brushPrice;
        if (this.todayTotal) this.todayTotal.textContent = this.formatMoney(today);
        if (this.recurring) this.recurring.hidden = !withPlan;
      }

      syncRefillVariant(variant) {
        if (!this.isRefill || !variant || !this.refillVariantMap.length) return;
        const options = (variant.options || [variant.option1, variant.option2, variant.option3]).filter(Boolean);
        const match = this.refillVariantMap.find((item) => {
          const itemOptions = item.options || [item.option1];
          if (itemOptions.includes(options[0])) return true;
          return options.every((opt, index) => !itemOptions[index] || itemOptions[index] === opt);
        });
        if (match?.id) this.dataset.refillVariant = String(match.id);
      }

      syncAtcLabel() {
        if (!this.isRefill) return;
        const label = this.root.querySelector('.pdp-atc__label');
        if (!label) return;
        label.textContent = this.mode === 'subscribe' ? this.atcPlanLabel : this.atcDefaultLabel;
      }

      syncAtcPrices() {
        const root = this.closest('product-info') || document;
        const atcPrice = root.querySelector('[data-pdp-atc-price]');
        const atcCompare = root.querySelector('[data-pdp-atc-compare]');
        if (!atcPrice) return;

        if (this.isRefill) {
          atcPrice.textContent = this.formatMoney(this.brushPrice);
          if (atcCompare) atcCompare.hidden = true;
          return;
        }

        if (this.mode === 'subscribe' && this.selectedOption) {
          const price = this.scaledPlanPrice();
          const compare = this.packCompare || this.packPrice;
          atcPrice.textContent = this.formatMoney(price);
          if (atcCompare) {
            atcCompare.textContent = this.formatMoney(compare);
            atcCompare.hidden = compare <= price;
          }
        } else {
          atcPrice.textContent = this.formatMoney(this.packPrice);
          if (atcCompare) {
            if (this.packCompare > this.packPrice) {
              atcCompare.textContent = this.formatMoney(this.packCompare);
              atcCompare.hidden = false;
            } else {
              atcCompare.hidden = true;
            }
          }
        }
      }

      async onFormSubmit(event) {
        this.bindForm();
        if (!this.isRefill || this.mode !== 'subscribe' || this.adding) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        await this.addBrushAndHeads();
      }

      brushVariantId() {
        const input = this.form?.querySelector('[name="id"]');
        return input ? input.value : null;
      }

      async addBrushAndHeads() {
        const brushId = this.brushVariantId();
        const headId = this.dataset.refillVariant;
        const planId = this.refillPlanInput?.value;
        if (!brushId || !headId || !planId) return;

        const submit = this.form?.querySelector('[type="submit"]');
        this.adding = true;
        submit?.classList.add('btn--loading');
        submit?.setAttribute('aria-disabled', 'true');

        try {
          const sectionsToBundle = [];
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
          );

          const addUrl = window.FoxTheme?.routes?.cart_add_url || '/cart/add.js';
          const cartUrl = window.FoxTheme?.routes?.cart_url || '/cart.js';
          const fetchConfig = window.FoxTheme?.utils?.fetchConfig
            ? FoxTheme.utils.fetchConfig('javascript')
            : {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              };

          const response = await fetch(addUrl, {
            ...fetchConfig,
            body: JSON.stringify({
              items: [
                { id: brushId, quantity: 1 },
                { id: headId, quantity: 1, selling_plan: Number(planId) },
              ],
              sections: sectionsToBundle,
              sections_url: window.location.pathname,
            }),
          });
          const parsedState = await response.json();
          if (parsedState.status) throw new Error(parsedState.description || 'Add to cart failed');

          const cartConfig = window.FoxTheme?.utils?.fetchConfig
            ? FoxTheme.utils.fetchConfig()
            : { headers: { Accept: 'application/json' } };
          const cartJson = await (await fetch(cartUrl, { ...cartConfig })).json();
          cartJson.sections = parsedState.sections;

          if (window.FoxTheme?.pubsub?.publish) {
            FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
          }
          document.dispatchEvent(
            new CustomEvent('product-ajax:added', {
              detail: { product: parsedState },
            })
          );

          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && FoxTheme?.settings?.cartType !== 'page') {
            cartDrawer.show(submit);
          }
        } catch (error) {
          console.warn(error);
        } finally {
          this.adding = false;
          submit?.classList.remove('btn--loading');
          submit?.removeAttribute('aria-disabled');
        }
      }

      toggleDropdown() {
        if (!this.list) return;
        if (this.list.hasAttribute('hidden')) this.openDropdown();
        else this.closeDropdown();
      }

      openDropdown() {
        if (!this.list || !this.trigger) return;
        this.list.removeAttribute('hidden');
        this.trigger.setAttribute('aria-expanded', 'true');
        this.dropdown?.classList.add('is-open');
      }

      closeDropdown() {
        if (!this.list || !this.trigger) return;
        this.list.setAttribute('hidden', '');
        this.trigger.setAttribute('aria-expanded', 'false');
        this.dropdown?.classList.remove('is-open');
      }

      formatMoney(cents) {
        const value = Math.round(Number(cents) || 0);
        if (window.FoxTheme?.Currency?.formatMoney) {
          return FoxTheme.Currency.formatMoney(value, '${{amount}}');
        }
        return `$${(value / 100).toFixed(2)}`;
      }
    }
  );
}
